import { useMemo, useState } from 'react';
import Toast from 'common/components/atoms/Toast';
import styled from 'styled-components';
import { Z_INDEX } from 'common/styles';
import ToastCtx from 'common/contexts/ToastContext';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

const ToastContainer = styled.div`
  position: fixed;
  top: 32px;
  right: 16px;
  z-index: ${Z_INDEX.TOAST};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

interface IToaster {
  children: React.ReactNode
}

const Toaster: React.FC<IToaster> = ({ children }) => {
  const [toasts, setToast] = useState<any[]>([]);
  const value = useMemo(() => ({ toasts, setToast }), [toasts]);

  // from here now on 'armageddon' is a verb
  const armageddonToast = (toastId: number):void => {
    setToast((prevState: any[]) => prevState
      .filter((item) => item.id !== toastId))
  };

  return (
    <ToastCtx.Provider value={value}>
      <ToastContainer>
        <TransitionGroup>
          {toasts.map((toast) => (
            <CSSTransition
              key={toast.id}
              classNames="toast"
              timeout={500}
            >
              <Toast
                text={toast.text}
                variant={toast.variant}
                onDismiss={() => armageddonToast(toast.id)}
              />
            </CSSTransition>
          ))}
        </TransitionGroup>
      </ToastContainer>
      {children}
    </ToastCtx.Provider>
  );
};

export default Toaster;
